<template>

	<a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ paddingTop: 0, }">
		<template #title>
			<a-row type="flex" align="middle">
				<a-col :span="24" :md="12">
					<h6 class="font-semibold m-0">绑定卡号</h6>
				</a-col>
				<a-col :span="24" :md="12" style="display: flex; align-items: center; justify-content: flex-end">
					<a-button type="primary" @click="showModal(1)" :disabled="financial.length >= 2">
						新增
					</a-button>
				</a-col>
			</a-row>
		</template>
		<a-row :gutter="[24, 24]">
			<a-col :span="24" :md="12" v-for="(item, key) in financial" :key="key">
				<a-card class="payment-method-card">
					<img src="images/logos/mastercard-logo.png" alt="" v-if="item.type === 'master'">
					<img src="images/logos/visa-logo.png" alt="" v-if="item.type === 'visa'">
					<h6 class="card-number"
						style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;padding-left: 5px;">{{
							item.bankCardNo }}</h6>
					<a-button type="link" @click="showModal(3, key, item)">
						<svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path class="fill-danger" fill-rule="evenodd" clip-rule="evenodd"
								d="M9 2C8.62123 2 8.27497 2.214 8.10557 2.55279L7.38197 4H4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6L4 16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V6C16.5523 6 17 5.55228 17 5C17 4.44772 16.5523 4 16 4H12.618L11.8944 2.55279C11.725 2.214 11.3788 2 11 2H9ZM7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V8ZM12 7C11.4477 7 11 7.44772 11 8V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V8C13 7.44772 12.5523 7 12 7Z"
								fill="#111827" />
						</svg>
					</a-button>
					<a-button type="link" @click="showModal(2, key, item)">
						<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path class="fill-gray-7"
								d="M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z" />
							<path class="fill-gray-7"
								d="M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z" />
						</svg>
					</a-button>
				</a-card>
			</a-col>
		</a-row>

		<a-modal v-model="visible" :title="title" on-ok="handleOk">
			<template slot="footer">
				<a-button key="back" @click="handleCancel">
					返回
				</a-button>
				<a-button key="submit" type="primary" :loading="loading" @click="handleOk">
					提交
				</a-button>
			</template>
			<div style="margin-bottom: 10px;">
				<a-row type="flex" align="middle">
					<a-col :span="4" :md="4" style="display: flex; align-items: center; justify-content: center">
						<div style="font-weight: 600;">银行卡号
						</div>
					</a-col>
					<a-col :span="20" :md="20">
						<a-input v-model="info.bankCardNo" @change="handleChange" placeholder="" />
					</a-col>
				</a-row>
			</div>
			<div style="margin-bottom: 10px;">
				<a-row type="flex" align="middle">
					<a-col :span="4" :md="4" style="display: flex; align-items: center; justify-content: center">
						<div style="font-weight: 600;">银行名称
						</div>
					</a-col>
					<a-col :span="20" :md="20">
						<a-input v-model="info.bankName" placeholder="" />
					</a-col>
				</a-row>
			</div>
			<div style="margin-bottom: 10px;">
				<a-row type="flex" align="middle">
					<a-col :span="4" :md="4" style="display: flex; align-items: center; justify-content: center">
						<div style="font-weight: 600;">银行渠道
						</div>
					</a-col>
					<a-col :span="20" :md="20">
						<a-radio-group v-model="info.type">
							<a-radio-button value="master">
								万事达卡
							</a-radio-button>
							<a-radio-button value="visa">
								VISA
							</a-radio-button>
						</a-radio-group>
					</a-col>
				</a-row>
			</div>
		</a-modal>
	</a-card>

</template>

<script>
import { upUserPayInfo } from '../../utils/user';
import { successNotification, warnNotification } from '../../utils/util';

export default ({
	data() {
		return {
			loading: false,
			visible: false,
			title: "",
			userInfo: {},
			info: { bankCardNo: "", bankName: "", type: "" },
			financial: [],
		}
	},
	mounted: function () {
		this.userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
		if (this.userInfo.financialInfo) {
			this.financial = JSON.parse(this.userInfo.financialInfo);
		}
	},
	methods: {
		showModal(type, i, info) {
			if (type == 1) {
				this.info = { bankCardNo: "", bankName: "" };
				this.title = "新增";
			} else if (type == 2) {
				info.up = i;
				this.info = info;
				this.title = "修改";
			}
			else if (type == 3) {
				info.del = i;
				this.info = info;
				this.title = "删除";
			}
			this.visible = true;
		},
		handleOk(e) {
			this.loading = true;
			upUserPayInfo(JSON.stringify(this.info)).then(data => {
				if (data.code === 0) {
					successNotification("成功", "更新成功");
					this.financial = JSON.parse(data.financialInfo);
					this.userInfo.financialInfo = JSON.stringify(this.financial);
					sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
					setTimeout(() => {
						this.visible = false;
						this.loading = false;
					}, 100);
				} else {
					warnNotification("失败", data.msg);
				}
			})
				.catch(err => {
					console.info("err:", err)
					this.loading = false;
				})
		},
		handleCancel(e) {
			this.info = { bankCardNo: "", bankName: "", type: "" };
			this.title = "";
			this.visible = false;
		},
		handleChange(e) {
			this.info.bankCardNo = this.info.bankCardNo.replace(/\D/g, '');
			// 添加空格，每4位一个空格
			let newValue = '';
			for (let i = 0; i < this.info.bankCardNo.length; i += 4) {
				newValue += this.info.bankCardNo.substr(i, 4) + ' ';
			}
			// 移除最后一个空格（如果存在）
			if (newValue.endsWith(' ')) {
				newValue = newValue.slice(0, -1);
			}
			this.info.bankCardNo = newValue;
		}
	},
})

</script>